/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_This_YearInputs */

const en_ui_filter_this_year = /** @type {(inputs: Ui_Filter_This_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this year`)
};

const de_ui_filter_this_year = /** @type {(inputs: Ui_Filter_This_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dieses Jahr`)
};

/**
* | output |
* | --- |
* | "this year" |
*
* @param {Ui_Filter_This_YearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_this_year = /** @type {((inputs?: Ui_Filter_This_YearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_This_YearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_this_year(inputs)
	return de_ui_filter_this_year(inputs)
});